import { actionTypes } from 'redux/actions/promts'

export interface IPresetPrompt {
  content: string
  created_at_ts: number
  created_by: string
  oid: string
  title: string
}

export interface IPrompt {
  data: {
    title?: string
    content?: string
    prompt_type: number
  }
  prompt: string
  users?: string[]
  groups?: string[]
  tags?: string[]
}

export interface PromptsState {
  prompts: IPresetPrompt[]
  isLoading: boolean
}

export const initialState = {
  prompts: [],
  isLoading: false,
}

export const promptsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.SET_IS_PROMPTS_LOADING:
      return { ...state, isLoading: action.payload }
    case actionTypes.SET_PROMPTS:
      return { ...state, prompts: action.payload }
    default:
      return state
  }
}
